import React, { Component } from 'react';
import CheckoutForm from './CheckoutForm';

class CheckoutComponent extends Component {
	constructor(props) {
		super(props);

		this.setVoucherDataSubmit = this.setVoucherDataSubmit.bind(this);
	}

	setVoucherDataSubmit(handle) {
		this.props.onPaymentMethodInit(this.props.paymentMethod, { voucherDataSubmitHandle: handle });
	}

	render() {
		return <div style={{ marginTop: '20px' }}>
			<CheckoutForm setVoucherDataSubmit={this.setVoucherDataSubmit} />
		</div>;
	}
}

export default CheckoutComponent;